export const productImages = {
  boxSet: 'https://cdn.magicpatterns.com/uploads/ptYNZBMS6S4eSrfMVmGh4b/Kit_premium_de_terapia_del_habla.png',
};

export const heroHighlights = ['3 Units', '5 Bonuses', '40 Pages', '72 Cards', '100% PDF'];

export const trustItems = [
  { value: 'PDF', label: '100% printable · 0 videos' },
  { value: 'Download', label: 'Digital delivery' },
  { value: '1:1 + Group', label: 'Session options' },
  { value: 'Letter + A4', label: 'Print sizes' },
];

export const problems = [
  'Spending your evenings building materials for tomorrow’s caseload',
  'Searching for a story that actually fits the target goal',
  'Cutting out picture cards and writing prompts by hand — again',
  'Writing comprehension questions and answer keys from scratch',
  'Improvising a game in the last minutes of the session',
  'Putting together home practice families will actually use',
];

export const solutionStats = [
  { value: '40', label: 'Printable pages' },
  { value: '3', label: 'Complete units' },
  { value: '72', label: 'Picture + prompt cards' },
  { value: '30 min', label: 'Session routes, plus shorter options' },
];

export const coverageChips = [
  '/r/',
  '/l/',
  '/s/',
  '/z/',
  '/sh/',
  '/ch/',
  'Voiceless /th/',
  'Individual & small group',
  'General American English',
];

export const units = [
  {
    id: 'school',
    pages: 'Unit 01 · Pages 4–15',
    title: 'Back to School',
    body: 'Question-and-answer practice built around familiar school people, objects and places.',
    focus: 'Who · What · Where · School Supply Hunt',
    tone: 'mint',
  },
  {
    id: 'people',
    pages: 'Unit 02 · Pages 16–27',
    title: 'All About Me',
    body: 'Meaningful sentences using characters with stated pronouns and clear action contexts.',
    focus: 'He · She · Plural they · Character Switch',
    tone: 'white',
  },
  {
    id: 'apple',
    pages: 'Unit 03 · Pages 28–39',
    title: 'Apples',
    body: 'Color, shape, size, texture and taste explored through story details and language prompts.',
    focus: 'Describe · Explain · Compare · Attribute Detective',
    tone: 'teal',
  },
] as const;

export const unitIncludes = [
  'Session plan',
  'Read-aloud story',
  'Comprehension + articulation bank',
  '12 picture cards',
  'Learner worksheet',
  '12 prompt cards',
  'Practice board',
  'Data sheet',
  '2 home handouts',
  'Answer key',
];

export const samples = [
  {
    title: 'Three themed units in one kit',
    body: 'Session plans, printable activities, picture cards, games, data sheets and home practice — organized by unit.',
    image: 'https://cdn.magicpatterns.com/uploads/4XTTdC8y4FKnMFmx1sYHsy/01_portada.png',
    alt: 'Kit cover page: Fall Sessions Starter Kit, Volume 01, with previews of units 1 to 3',
  },
  {
    title: 'Picture cards, ready to cut',
    body: '12 line-drawn theme cards per unit. Print single-sided, cut once and reuse them every session.',
    image: 'https://cdn.magicpatterns.com/uploads/itpV5AiZxnbunCnB1TYucQ/02_tarjetas_ilustradas.png',
    alt: 'Unit 1 Back to School theme picture cards page with 12 line drawings',
  },
  {
    title: 'A 20-space practice board',
    body: 'Pronoun practice with characters who state their pronouns. Movement never depends on accuracy.',
    image: 'https://cdn.magicpatterns.com/uploads/mDSe8F4KZuzJtC5gmyRQ9D/03_tablero_all_about_me.png',
    alt: 'Unit 2 All About Me practice board with 20 spaces and game rules',
  },
  {
    title: 'Worksheets with a separate answer key',
    body: '8 describing tasks your helper reads aloud. Answers live in the professional answer key.',
    image: 'https://cdn.magicpatterns.com/uploads/uBKuaK2WhcWumSdEza5VDT/04_hoja_manzanas.png',
    alt: 'Unit 3 Apples language worksheet on describing attributes',
  },
  {
    title: 'A board for every theme',
    body: 'Describe color, shape, size, texture and taste on the way to the finish line.',
    image: 'https://cdn.magicpatterns.com/uploads/q9iETWMTyZEHp2PA3KLVtt/05_tablero_manzanas.png',
    alt: 'Unit 3 Apples practice board with orchard path and rules',
  },
];

export const bonuses = [
  {
    title: 'The 20-Minute Backup Session Kit',
    benefit: 'A ready plan for the day the schedule changes and you only have 20 minutes.',
    cover: 'https://cdn.magicpatterns.com/uploads/c2GtcVuYUwwSko1UCSihdM/spech_1.webp',
  },
  {
    title: 'Mixed-Goal Group Session Planner',
    benefit: 'Plan one group session when every student is working on a different goal.',
    cover: 'https://cdn.magicpatterns.com/uploads/26AssbTHxJEBVkQwRCtvHG/spech_2.webp',
  },
  {
    title: 'The Home Practice Handout Library',
    benefit: 'Handouts you can send home so families keep practicing between sessions.',
    cover: 'https://cdn.magicpatterns.com/uploads/pJtjJC4xTX6SU1M854oLbs/spech3.webp',
  },
  {
    title: 'One Activity, Three Support Levels',
    benefit: 'Adjust the same activity to the level of support each student needs.',
    cover: 'https://cdn.magicpatterns.com/uploads/nmWarbd8d41QwrcybzU8i4/spech_4.webp',
  },
  {
    title: 'The Session Admin Template Pack',
    benefit: 'Templates for the paperwork around your sessions, so admin takes less time.',
    cover: 'https://cdn.magicpatterns.com/uploads/keV4vh664KgTrqbm6iUaXZ/spech_5.webp',
  },
];

export const includedItems = [
  '3 complete units',
  '5 bonuses',
  '40 printable pages',
  '36 picture cards',
  '36 language prompt cards',
  '6 home-practice handouts',
  'Data sheets + answer keys',
  '100% PDF · 0 videos',
];

export const comparison = [
  { without: 'Evenings spent building materials', with: 'Plan, story and cards ready to print' },
  { without: 'Hunting for a story that fits the goal', with: 'An original read-aloud story per unit' },
  { without: 'Writing questions and answer keys', with: '10 story questions + separate answer key' },
  { without: 'Improvising the last activity', with: 'A practice board and a repeat-session activity' },
  { without: 'Home practice put together last minute', with: 'Two home handouts in every unit' },
];

export const contentFaqs = [
  {
    q: 'What exactly is included?',
    a: 'A 40-page PDF with three complete themed units: Back to School, All About Me and Apples. Each unit has a session plan, read-aloud story, comprehension and articulation bank, 12 picture cards, a worksheet, 12 prompt cards, a practice board, a data sheet, two home handouts and an answer key — plus five bonuses.',
  },
  {
    q: 'Who is it for, and what level?',
    a: 'Speech and language professionals working with children in English, in individual or small-group sessions. You select the goal, response mode and support for each student; the kit does not replace assessment or clinical judgment.',
  },
  {
    q: 'Can I use it with students who don’t read yet?',
    a: 'Yes. Activities work with adult read-aloud instructions. You choose spoken, pointing, written or established communication responses for language tasks.',
  },
  {
    q: 'What speech sounds are covered?',
    a: 'Word banks include selected resources for /r/, /l/, /s/, /z/, /sh/, /ch/ and voiceless /th/, with General American English as the reference variety.',
  },
  {
    q: 'What do I need to use it?',
    a: 'A printer (US Letter, or A4 with fit-to-page), scissors, pencils or crayons and a simple token per player. Pages use line drawings suited to grayscale printing. First use includes cutting the cards; you can reuse them afterward.',
  },
  {
    q: 'Are there videos?',
    a: 'No. Everything is in PDF format — 0 videos. You open the file, choose the pages and print.',
  },
  {
    q: 'Is a physical book shipped?',
    a: 'No. It is a digital PDF download. No physical product is shipped.',
  },
];
